import React, { useState } from "react";
import axios from "axios";
import logo from "../assets/logo.png";
import logo2 from "../assets/logo2.png";
import './CSS/Login.css';

const OTPAuthentication = () => {
  const [phone, setPhone] = useState("+66");
  const [message, setMessage] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!phone || !phone.startsWith("+66")) {
      setMessage("⚠️ Please enter a valid Thai phone number (e.g., +66855609710).");
      return;
    }

    try {
      setIsLoading(true);
      setMessage("Sending OTP...");

      const res = await axios.post("/send-otp-phone", { phone_number: phone });

      if (res.status === 200) {
        setMessage("✅ OTP sent successfully! Please check your phone.");
      } else {
        setMessage("❌ Failed to send OTP.");
      }
    } catch (err) {
      console.error(err);
      setMessage("❌ " + (err.response?.data?.message || "Failed to send OTP."));
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="otp-container d-flex align-items-center justify-content-center">
      <div className="text-center" style={{ width: "100%", maxWidth: "420px" }}>
        {/* Logo */}
        <img className="logo mb-3" src={logo} alt="Logo" />
        <h3>📱 Test Send OTP</h3>
        <p className="text-muted">
          Enter your phone number in <strong>+66 format</strong> to receive a test OTP.
        </p>

        {/* Card */}
        <div className="card shadow-sm mt-3">
          <div className="card-body">
            <form onSubmit={handleSubmit}>
              <div className="form-group mb-3 text-start">
                <label htmlFor="phone">Phone Number</label>
                <input
                  type="tel"
                  id="phone"
                  className="form-control"
                  placeholder="+66812345678"
                  value={phone}
                  onChange={(e) => setPhone(e.target.value)}
                  required
                />
              </div>

              <button
                type="submit"
                className="btn btn-dark w-100"
                disabled={isLoading}
              >
                {isLoading ? "Sending..." : "Send OTP"}
              </button>
            </form>

            {message && (
              <div
                className="alert mt-3 py-2"
                style={{
                  backgroundColor: "#f9f9f9",
                  border: "1px solid #ddd",
                  color: "#333",
                }}
              >
                {message}
              </div>
            )}

            {/* Footer */}
            <div className="mt-4 text-center small text-muted">
              <p>Powered by</p>
              <img
                src={logo2}
                alt="Logo 2"
                style={{ width: "90px", opacity: 0.85 }}
              />
            </div>
          </div>
        </div>

        <div className="mt-4 small text-muted">
          Need help? Contact support.
        </div>
      </div>
    </div>
  );
};

export default OTPAuthentication;
